import React, { useState } from "react";
import Sidebar from "../sidebar/sidebar";
import Header from "../header/header";
import {
  Title, Subtitle, PillContainer, PillButton,
  PageShell, SidebarPane, ContentPane, StickyHeader, MainWrapper, InnerWrapper,
} from "./NetZeroDashboard.styles";
import { TABS, useNetzeroData } from "./netzero.utils";
import { ConfigSummaryCards, ScopePathwayPanel, Scope3Panel } from "./NetZeroScopePanels";
import HorizonDashboardContainer from "./HorizonDashboard";


const NetZeroDashboard = (props) => {
  const [activeTab, setActiveTab] = useState("scope-1");
  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  const { loading, settings, scopes } = useNetzeroData();

  return (
    <PageShell className="mainclass">
      <SidebarPane $expanded={sidebarExpanded}>
        <Sidebar dataFromParent={props.location?.pathname} onSidebarToggle={setSidebarExpanded} />
      </SidebarPane>

      <ContentPane $expanded={sidebarExpanded}>
        <StickyHeader>
          <Header />
        </StickyHeader>

        <MainWrapper className="main_wrapper" $expanded={sidebarExpanded}>
          <InnerWrapper className="inner_wraapper px-3 pt-3 scroll-container">
            <Title>Net Zero</Title>
            <Subtitle>Science-based targets — required vs actual emissions per scope (SBTi Corporate Net-Zero Standard)</Subtitle>

            <ConfigSummaryCards setting={settings} />

            <PillContainer>
              {TABS.map((t) => (
                <PillButton key={t.key} $active={activeTab === t.key} onClick={() => setActiveTab(t.key)}>
                  {t.label}
                </PillButton>
              ))}
            </PillContainer>

            {activeTab === "scope-1" ? (
              <ScopePathwayPanel scope={1} data={scopes[1]} loading={loading} />
            ) : activeTab === "scope-2" ? (
              <ScopePathwayPanel scope={2} data={scopes[2]} loading={loading} />
            ) : (
              <Scope3Panel data={scopes[3]} loading={loading} />
            )}

            <HorizonDashboardContainer
              scope1Data={scopes[1]}
              scope2Data={scopes[2]}
              scope3Data={scopes[3]}
              loading={loading}
            />
          </InnerWrapper>
        </MainWrapper>
      </ContentPane>
    </PageShell>
  );
};

export default NetZeroDashboard;
